import React from "react";

import { useTheme } from "../../../../../../context/theme";
import useShadow from "../../../../../../styles/shadows/useShadow";
import { Dimension } from "../../../../../../types";
import { Box, Stack } from "../../../../../layout";
import { Position } from "../../../../types";

type MenuProps = {
  children: React.ReactNode;
  position?: Position;
};

export const ContextMenu = React.forwardRef<any, MenuProps>(
  (props: MenuProps, ref) => {
    const { children, position } = props;

    const theme = useTheme();
    const shadow = useShadow("large");

    const styles = getMenuStyles(position);

    return (
      <Box
        zIndex={2}
        backgroundColor={theme.foreground}
        boxShadow={shadow}
        overflow="hidden"
        {...styles}
      >
        <Stack ref={ref}>{children}</Stack>
      </Box>
    );
  }
);

export default ContextMenu;

const getMenuStyles = (position?: string) => {
  if (position === "bottomLeft") {
    return {
      borderRadius: "xsmall" as Dimension,
      borderTopRightRadius: "none" as Dimension
    };
  }

  if (position === "bottomRight") {
    return {
      borderRadius: "xsmall" as Dimension,
      borderTopLeftRadius: "none" as Dimension
    };
  }

  return {
    borderRadius: "xsmall" as Dimension
  };
};
